export const areaOptions = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県"
];

// from "code-repository"."channels".ja
export const channelOptions = [
  "スーパー",
  "コンビニ",
  "専門店",
  "ホームセンター",
  "ディスカウントストア",
  "薬局・ドラッグストア",
  "１００円ショップ",
  "百貨店",
  "オンラインショッピング（楽天、Amazonなど）",
  "生協など、食材宅配サービス",
  "通信販売・カタログ通販",
  "駅などの売店",
  "アウトレット店",
  "家電量販店",
  "テレビ・ラジオショッピング",
  "ディスカウントストア・ホームセンター",
  "携帯電話・phsのインターネット情報サービス（iモードなど）",
  "共同購入",
  "コンビニ店内などにあるマルチメディア端末",
  "自動販売機",
  "その他",
];

export const genderAgeOptions = [
  "女性15-19",
  "女性20-24",
  "女性25-29",
  "女性30-34",
  "女性35-39",
  "女性40-44",
  "女性45-49",
  "女性50-54",
  "女性55-59",
  "女性60-64",
  "女性65-69",
  "男性15-19",
  "男性20-24",
  "男性25-29",
  "男性30-34",
  "男性35-39",
  "男性40-44",
  "男性45-49",
  "男性50-54",
  "男性55-59",
  "男性60-64",
  "男性65-69",
];
